import { render } from "./CookiesContent.vue?vue&type=template&id=4c6998d2&scoped=true"
import script from "./CookiesContent.vue?vue&type=script&lang=js"
export * from "./CookiesContent.vue?vue&type=script&lang=js"

import "./CookiesContent.vue?vue&type=style&index=0&id=4c6998d2&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6998d2"]])

export default __exports__